/** @format */
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { lettersOnly } from '../../Config/Regex';
import { posVersionService } from '../../Services/posVersion.services';

const UpdatePosVersion = ({
	onSuccess,
	setResultModal,
	updateData,
	disabled,
}) => {
	const { t: translator } = useTranslation();
	const { register, handleSubmit, errors, setValue } = useForm({
		mode: 'onChange',
		reValidateMode: 'onChange',
	});

	useEffect(() => {
		setValue('name', updateData.name, { shouldValidate: true });
	}, [updateData]);

	const onSubmit = data => {
		posVersionService
			.update(updateData.posVersionId, data.name,data.isCurrent)
			.then(res => {
				onSuccess();
				setResultModal({
					show: true,
					title: translator('PosVersion-UpdateCardType-SuccesModal-Title'),
					text: translator(res.data.message),
					btnClass: 'btn btn-primary',
				});
			})
			.catch(err => console.log(err));
	};
	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			className='p-4'
			style={{ border: '1px solid lightgray' }}>
			<h5 className='mb-4 text-center font-weight-bold'>
				{translator('PosVersion-Update')}
			</h5>

			<fieldset className='scheduler-border'>
				<div className='form-group'>
					<label>{translator('Administration-PosVersion-Name')}</label>
					<input
						type='text'
						className='form-control'
						ref={register({
							required: true,
							//pattern: lettersOnly,
							maxLength: 20,
						})}
						defaultValue={updateData.name}
						name='name'
						disabled={true}
					/>
					{errors.name && errors.name.type === 'required' && (
						<p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
					)}
					{errors.name && errors.name.type === 'pattern' && (
						<p className='text-danger'>{translator('ValidationMsg-LettersOnly')}</p>
					)}
					{errors.name && errors.name.type === 'maxLength' && (
						<p className='text-danger'>{translator('ValidationMsg-MaxLength20')}</p>
					)}
				</div>
				 <div className="form-group col-12">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="isCurrent"
                      ref={register}
                      defaultChecked={
                         updateData.isCurrent 
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>{translator("Postavi kao trenutnu")}</span>{" "}
                 
                </div>
			</fieldset>

			<div className='d-flex justify-content-end mt-2'>
				<button className='btn btn-primary' type='submit' disabled={disabled}>
					{translator('Btn-Save')}
				</button>
			</div>
		</form>
	);
};

export default UpdatePosVersion;
